<div class="qar-std-desc-edit-modal">
  <div class="modal-header">
    <h3 class="modal-title">{{ editorTitle }}</h3>
    <div class="header-actions">
      <i class="fa"
         [class.fa-plus-square-o]="minimise"
         [class.fa-minus-square-o]="!minimise"
         role="button"
         tabindex="0"
         [attr.title]="minimise ? 'Restore' : 'Minimize'"
         [attr.aria-label]="minimise ? 'Restore dialog' : 'Minimize dialog'"
         (click)="minimise = !minimise"
         (keydown.enter)="minimise = !minimise"
         (keydown.space)="$event.preventDefault(); minimise = !minimise"></i>
      <i class="fa fa-times"
         role="button"
         tabindex="0"
         title="Close"
         aria-label="Close"
         (click)="cancel()"
         (keydown.enter)="cancel()"
         (keydown.space)="$event.preventDefault(); cancel()"></i>
    </div>
  </div>

  <div class="modal-body" [hidden]="minimise">
    <div class="form-group">
      <label>QAR Standard Description*</label>
      <input class="form-control" type="text" [(ngModel)]="stdDesc" name="stdDesc" (input)="descTouched = true" />
      @if (descTouched && !stdDesc.trim()) {
        <div class="form-error-container">QAR Standard Description is required.</div>
      }
      @if (descTouched && isDuplicateDesc) {
        <div class="form-error-container">QAR Standard Description must be unique.</div>
      }
    </div>
    <div class="form-group">
      <label>System Flag</label>
      <select class="form-control" [(ngModel)]="selectedSystemFlag" name="systemFlag">
        @for (flag of systemFlag; track flag) {
          <option [ngValue]="flag">{{ flag }}</option>
        }
      </select>
    </div>
  </div>

  <div class="modal-footer" [hidden]="minimise">
    <button class="save-button" type="button" [disabled]="!canSave" (click)="save()">
      @if (saving) {
        <span><i class="fa fa-spinner fa-pulse"></i></span>
      }Save
    </button>
    <button class="reset-button" type="button" (click)="resetForm()">Reset Form</button>
    <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
  </div>
</div>
